
import {
  defineComponent, reactive, watch,
} from 'vue';
import { useTelaBase } from '@/core/composables/TelaBase';
import { useModalBase } from '@/core/composables/ModalBase';
import { useGradeBase } from '@/core/composables/GradeBase';
import Icone from '@/core/components/Icone.vue';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import storeSistema from '@/store/storeSistema';
import CampoNumerico from '@/core/components/Tela/CampoNumerico.vue';
import Card from '@/core/components/Tela/Card.vue';
import { IKitProdutosItem } from '@/models/Entidades/Cadastros/Produtos/IKitProdutos';
import MensagemSemDados from '@/core/components/Tela/MensagemSemDados.vue';
import ServicoKitProdutos from '@/servicos/Cadastros/Produtos/ServicoKitProdutos';
import SelecionarKitProdutos from './SelecionarKitProdutos.vue';

export default defineComponent({
  name: 'KitsProdutosModal',
  props: {
    visivel: {
      type: Boolean,
      default: false,
    },
    empresa: {
      type: Number,
      required: true,
    },
  },
  components: {
    Icone,
    Card,
    CampoNumerico,
    MensagemSemDados,
    SelecionarKitProdutos,
  },
  emits: ['update:visivel', 'confirmacao'],
  setup(props, { emit }) {
    const { telaBase, apresentarMensagemAlerta } = useTelaBase();
    const { modalBase } = useModalBase(props, emit);
    const { gradeBase } = useGradeBase();
    const servicoKitProdutos = new ServicoKitProdutos();
    servicoKitProdutos.requisicaoSistema();

    const state = reactive({
      itens: [] as IKitProdutosItem[],
      kitSelecionado: 0,
      carregando: false,
    });

    function limparTela() {
      state.itens = [] as IKitProdutosItem[];
      state.kitSelecionado = 0;
      state.carregando = false;
    }

    async function obterItens() {
      state.carregando = true;
      state.itens = await servicoKitProdutos.obterItens(state.kitSelecionado, props.empresa);
      state.carregando = false;
    }

    function utilizar() {
      if (!state.kitSelecionado) {
        apresentarMensagemAlerta('Selecione um kit de produtos.');
        return;
      }
      emit('confirmacao', state.itens);
      modalBase.computedVisivel = false;
    }

    watch(async () => modalBase.computedVisivel, async () => {
      telaBase.carregando = true;
      limparTela();
      if (modalBase.computedVisivel) {
        console.log('');
      }
      telaBase.carregando = false;
    });

    return {
      props,
      state,
      emit,
      telaBase,
      modalBase,
      gradeBase,
      storeSistema,
      UtilitarioGeral,
      obterItens,
      utilizar,
    };
  },
});
